import React, { MouseEventHandler } from "react";

interface IButtonProps {
    canClick?: boolean;
    loading?: boolean;
    actionText: string;
    onClick?: MouseEventHandler<HTMLButtonElement>;
    style?: string;
}

export const Button: React.FC<IButtonProps> = ({
    canClick = true,
    loading = false,
    actionText,
    style = "",
    onClick = () => { },
}) => (
    <button
        className={`rounded-full py-3 px-6 text-lg font-medium focus:outline-none text-white py-4  transition-colors ${canClick
            ? " bg-gradient-to-r from-green-400 to-blue-500 hover:from-pink-500 hover:to-yellow-500"
            : "bg-gray-300 pointer-events-none "
            } ${style}`}
        onClick={onClick}
    >
        {loading ? "Loading..." : actionText}
    </button>
);